import { format } from "date-fns";
import { Filter, Users, Calendar, Clock } from "lucide-react";
import { useTranslation } from "react-i18next";
import { formatTimeRange } from "@/lib/utils/time";

interface FilterBarProps {
  groupSize: number;
  date: Date | undefined;
  startTime?: string;
  endTime?: string;
  onClick: (focusSection?: "time" | "date" | "group") => void;
}

export function FilterBar({
  groupSize,
  date,
  startTime = "10:00",
  endTime = "22:00",
  onClick,
}: FilterBarProps) {
  const { t, i18n } = useTranslation();
  const locale = i18n.language;

  return (
    <div
      onClick={() => onClick()}
      className="w-full flex items-center justify-between p-3 bg-card rounded-lg border shadow-sm hover:bg-accent/50 transition-all duration-200 hover:shadow-md cursor-pointer"
    >
      {/* Filter label */}
      <div className="flex items-center gap-2 text-sm">
        <Filter className="h-4 w-4 text-black" />
        <span className="font-medium text-black">
          {t("booking.shows.filters.title")}
        </span>
      </div>

      {/* Group size */}
      <div
        onClick={(e) => {
          e.stopPropagation();
          onClick("group");
        }}
        className="flex items-center gap-1.5 text-sm text-black cursor-pointer hover:text-purple-700 transition-colors"
      >
        <Users className="h-3.5 w-3.5" />
        <span className="whitespace-nowrap">{groupSize}p</span>
      </div>

      {/* Date */}
      <div
        onClick={(e) => {
          e.stopPropagation();
          onClick("date");
        }}
        className="flex items-center gap-1.5 text-sm text-black cursor-pointer hover:text-purple-700 transition-colors"
      >
        <Calendar className="h-3.5 w-3.5" />
        <span className="whitespace-nowrap">
          {date ? format(date, "MMM d") : t("booking.shows.filters.select")}
        </span>
      </div>

      {/* Time range */}
      {startTime && endTime && (
        <div
          onClick={(e) => {
            e.stopPropagation();
            onClick("time");
          }}
          className="flex items-center gap-1.5 text-sm text-black cursor-pointer hover:text-purple-700 transition-colors"
        >
          <Clock className="h-3.5 w-3.5" />
          <span className="whitespace-nowrap">
            {formatTimeRange(startTime, endTime, locale)}
          </span>
        </div>
      )}
    </div>
  );
}
